import { getServer } from "@/Utlis/connections/aplication/getServer";
import { postServer } from "@/Utlis/connections/aplication/postServer";
import { ConnectionRepository } from "@/Utlis/connections/infraestructure/ConnectionRepository";

export function PaymentRepository() {
    return {
        getLastPayment,
        postPayment,
        postPaymentUsdt,
        getLastPaymentV8,
        postPaymentV8,
        postPaymentUsdtV8
    }
}

const connect = ConnectionRepository()

async function getLastPayment(nick) {
    try {
        const payment = await getServer(connect, `v7/public/payment/${nick}`)
        return payment.data
    } catch (error) {
        console.error(`Error in PaymentRepository Method getLastPayment: ${error}`);
        return null
    }
}

async function postPayment(data) {
    const payment = await postServer(connect, "v7/public/payment", data)
    if (payment == null) {
        return null
    }
    return payment.data
}

async function postPaymentUsdt(data) {
    const payment = await postServer(connect, "v7/public/payment/usdt", data)
    if (payment == null) {
        return null
    }
    return payment.data
}

async function getLastPaymentV8(nick) {
    try {
        const payment = await getServer(connect, `v8/public/payment/${nick}`)
        return payment.data
    } catch (error) {
        console.error(`Error in PaymentRepository Method getLastPayment: ${error}`);
        return null
    }
}

async function postPaymentV8(data) {
    const payment = await postServer(connect, "v8/public/payment", data)
    if (payment == null) {
        return null
    }
    return payment.data
}

async function postPaymentUsdtV8(data) {
    const payment = await postServer(connect, "v8/public/payment/usdt", data)
    if (payment == null) {
        return null
    }
    return payment.data
}